// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.5
// source: roboverse_platform_protos/statekeeping/Reported/Payload/SpotCam.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Reported.Payload";

export interface SpotCam {
  availableCameras: SpotCam_SpotCamCamera[];
  currentStream: SpotCam_StreamSetting | undefined;
  forwardPosition: SpotCam_PtzPosition | undefined;
  isAvailable: boolean;
  isFrontMounted: boolean;
  isPtzIr: boolean;
  isLightsOn: boolean;
  currentPosition: SpotCam_PtzPosition | undefined;
}

export enum SpotCam_SpotCamCamera {
  UNKNOWN = 0,
  PTZ = 1,
  IR = 2,
  DIGI = 3,
  UNRECOGNIZED = -1,
}

export function spotCam_SpotCamCameraFromJSON(object: any): SpotCam_SpotCamCamera {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return SpotCam_SpotCamCamera.UNKNOWN;
    case 1:
    case "PTZ":
      return SpotCam_SpotCamCamera.PTZ;
    case 2:
    case "IR":
      return SpotCam_SpotCamCamera.IR;
    case 3:
    case "DIGI":
      return SpotCam_SpotCamCamera.DIGI;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpotCam_SpotCamCamera.UNRECOGNIZED;
  }
}

export function spotCam_SpotCamCameraToJSON(object: SpotCam_SpotCamCamera): string {
  switch (object) {
    case SpotCam_SpotCamCamera.UNKNOWN:
      return "UNKNOWN";
    case SpotCam_SpotCamCamera.PTZ:
      return "PTZ";
    case SpotCam_SpotCamCamera.IR:
      return "IR";
    case SpotCam_SpotCamCamera.DIGI:
      return "DIGI";
    case SpotCam_SpotCamCamera.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SpotCam_StreamSetting {
  camera: SpotCam_SpotCamCamera;
  compositorScreen: string;
  showSurroundView: boolean;
}

export interface SpotCam_PtzPosition {
  pan: number;
  tilt: number;
  zoom: number;
}

function createBaseSpotCam(): SpotCam {
  return {
    availableCameras: [],
    currentStream: undefined,
    forwardPosition: undefined,
    isAvailable: false,
    isFrontMounted: false,
    isPtzIr: false,
    isLightsOn: false,
    currentPosition: undefined,
  };
}

export const SpotCam: MessageFns<SpotCam> = {
  encode(message: SpotCam, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.availableCameras) {
      writer.int32(v);
    }
    writer.join();
    if (message.currentStream !== undefined) {
      SpotCam_StreamSetting.encode(message.currentStream, writer.uint32(18).fork()).join();
    }
    if (message.forwardPosition !== undefined) {
      SpotCam_PtzPosition.encode(message.forwardPosition, writer.uint32(26).fork()).join();
    }
    if (message.isAvailable !== false) {
      writer.uint32(32).bool(message.isAvailable);
    }
    if (message.isFrontMounted !== false) {
      writer.uint32(40).bool(message.isFrontMounted);
    }
    if (message.isPtzIr !== false) {
      writer.uint32(48).bool(message.isPtzIr);
    }
    if (message.isLightsOn !== false) {
      writer.uint32(56).bool(message.isLightsOn);
    }
    if (message.currentPosition !== undefined) {
      SpotCam_PtzPosition.encode(message.currentPosition, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpotCam {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotCam();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.availableCameras.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.availableCameras.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currentStream = SpotCam_StreamSetting.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.forwardPosition = SpotCam_PtzPosition.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isAvailable = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isFrontMounted = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.isPtzIr = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isLightsOn = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.currentPosition = SpotCam_PtzPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpotCam {
    return {
      availableCameras: globalThis.Array.isArray(object?.availableCameras)
        ? object.availableCameras.map((e: any) => spotCam_SpotCamCameraFromJSON(e))
        : [],
      currentStream: isSet(object.currentStream) ? SpotCam_StreamSetting.fromJSON(object.currentStream) : undefined,
      forwardPosition: isSet(object.forwardPosition) ? SpotCam_PtzPosition.fromJSON(object.forwardPosition) : undefined,
      isAvailable: isSet(object.isAvailable) ? globalThis.Boolean(object.isAvailable) : false,
      isFrontMounted: isSet(object.isFrontMounted) ? globalThis.Boolean(object.isFrontMounted) : false,
      isPtzIr: isSet(object.isPtzIr) ? globalThis.Boolean(object.isPtzIr) : false,
      isLightsOn: isSet(object.isLightsOn) ? globalThis.Boolean(object.isLightsOn) : false,
      currentPosition: isSet(object.currentPosition) ? SpotCam_PtzPosition.fromJSON(object.currentPosition) : undefined,
    };
  },

  toJSON(message: SpotCam): unknown {
    const obj: any = {};
    if (message.availableCameras?.length) {
      obj.availableCameras = message.availableCameras.map((e) => spotCam_SpotCamCameraToJSON(e));
    }
    if (message.currentStream !== undefined) {
      obj.currentStream = SpotCam_StreamSetting.toJSON(message.currentStream);
    }
    if (message.forwardPosition !== undefined) {
      obj.forwardPosition = SpotCam_PtzPosition.toJSON(message.forwardPosition);
    }
    if (message.isAvailable !== false) {
      obj.isAvailable = message.isAvailable;
    }
    if (message.isFrontMounted !== false) {
      obj.isFrontMounted = message.isFrontMounted;
    }
    if (message.isPtzIr !== false) {
      obj.isPtzIr = message.isPtzIr;
    }
    if (message.isLightsOn !== false) {
      obj.isLightsOn = message.isLightsOn;
    }
    if (message.currentPosition !== undefined) {
      obj.currentPosition = SpotCam_PtzPosition.toJSON(message.currentPosition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpotCam>, I>>(base?: I): SpotCam {
    return SpotCam.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpotCam>, I>>(object: I): SpotCam {
    const message = createBaseSpotCam();
    message.availableCameras = object.availableCameras?.map((e) => e) || [];
    message.currentStream = (object.currentStream !== undefined && object.currentStream !== null)
      ? SpotCam_StreamSetting.fromPartial(object.currentStream)
      : undefined;
    message.forwardPosition = (object.forwardPosition !== undefined && object.forwardPosition !== null)
      ? SpotCam_PtzPosition.fromPartial(object.forwardPosition)
      : undefined;
    message.isAvailable = object.isAvailable ?? false;
    message.isFrontMounted = object.isFrontMounted ?? false;
    message.isPtzIr = object.isPtzIr ?? false;
    message.isLightsOn = object.isLightsOn ?? false;
    message.currentPosition = (object.currentPosition !== undefined && object.currentPosition !== null)
      ? SpotCam_PtzPosition.fromPartial(object.currentPosition)
      : undefined;
    return message;
  },
};

function createBaseSpotCam_StreamSetting(): SpotCam_StreamSetting {
  return { camera: 0, compositorScreen: "", showSurroundView: false };
}

export const SpotCam_StreamSetting: MessageFns<SpotCam_StreamSetting> = {
  encode(message: SpotCam_StreamSetting, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.camera !== 0) {
      writer.uint32(8).int32(message.camera);
    }
    if (message.compositorScreen !== "") {
      writer.uint32(18).string(message.compositorScreen);
    }
    if (message.showSurroundView !== false) {
      writer.uint32(24).bool(message.showSurroundView);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpotCam_StreamSetting {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotCam_StreamSetting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.camera = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.compositorScreen = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.showSurroundView = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpotCam_StreamSetting {
    return {
      camera: isSet(object.camera) ? spotCam_SpotCamCameraFromJSON(object.camera) : 0,
      compositorScreen: isSet(object.compositorScreen) ? globalThis.String(object.compositorScreen) : "",
      showSurroundView: isSet(object.showSurroundView) ? globalThis.Boolean(object.showSurroundView) : false,
    };
  },

  toJSON(message: SpotCam_StreamSetting): unknown {
    const obj: any = {};
    if (message.camera !== 0) {
      obj.camera = spotCam_SpotCamCameraToJSON(message.camera);
    }
    if (message.compositorScreen !== "") {
      obj.compositorScreen = message.compositorScreen;
    }
    if (message.showSurroundView !== false) {
      obj.showSurroundView = message.showSurroundView;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpotCam_StreamSetting>, I>>(base?: I): SpotCam_StreamSetting {
    return SpotCam_StreamSetting.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpotCam_StreamSetting>, I>>(object: I): SpotCam_StreamSetting {
    const message = createBaseSpotCam_StreamSetting();
    message.camera = object.camera ?? 0;
    message.compositorScreen = object.compositorScreen ?? "";
    message.showSurroundView = object.showSurroundView ?? false;
    return message;
  },
};

function createBaseSpotCam_PtzPosition(): SpotCam_PtzPosition {
  return { pan: 0, tilt: 0, zoom: 0 };
}

export const SpotCam_PtzPosition: MessageFns<SpotCam_PtzPosition> = {
  encode(message: SpotCam_PtzPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pan !== 0) {
      writer.uint32(13).float(message.pan);
    }
    if (message.tilt !== 0) {
      writer.uint32(21).float(message.tilt);
    }
    if (message.zoom !== 0) {
      writer.uint32(29).float(message.zoom);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SpotCam_PtzPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotCam_PtzPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.pan = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.tilt = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.zoom = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpotCam_PtzPosition {
    return {
      pan: isSet(object.pan) ? globalThis.Number(object.pan) : 0,
      tilt: isSet(object.tilt) ? globalThis.Number(object.tilt) : 0,
      zoom: isSet(object.zoom) ? globalThis.Number(object.zoom) : 0,
    };
  },

  toJSON(message: SpotCam_PtzPosition): unknown {
    const obj: any = {};
    if (message.pan !== 0) {
      obj.pan = message.pan;
    }
    if (message.tilt !== 0) {
      obj.tilt = message.tilt;
    }
    if (message.zoom !== 0) {
      obj.zoom = message.zoom;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpotCam_PtzPosition>, I>>(base?: I): SpotCam_PtzPosition {
    return SpotCam_PtzPosition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpotCam_PtzPosition>, I>>(object: I): SpotCam_PtzPosition {
    const message = createBaseSpotCam_PtzPosition();
    message.pan = object.pan ?? 0;
    message.tilt = object.tilt ?? 0;
    message.zoom = object.zoom ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
